import { c as _c } from "react/compiler-runtime";
import { Box, Icon } from '@chakra-ui/react';
import { LANE } from '@src/components/sco/Admin/AiCrm/crmLane';
import type { CrmLaneKey } from '@src/components/sco/Admin/AiCrm/data/types';
import React from 'react';

/** A small colored tile with the lane's icon. Lists use it as a rule's marker. */
export function LaneTile(props) {
  const $ = _c(9);
  const meta = LANE[props.lane];
  const size = props.size || 7;
  const t0 = size > 6 ? 4 : 3.5;
  let t1;
  if ($[0] !== meta.Icon) {
    t1 = <meta.Icon />;
    $[0] = meta.Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = <Icon boxSize={t0} color="colorPalette.fg">{t1}</Icon>;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== meta.palette || $[6] !== size || $[7] !== t2) {
    t3 = <Box alignItems="center" bg="colorPalette.muted" borderRadius="md" boxSize={size} colorPalette={meta.palette} display="flex" flexShrink={0} justifyContent="center">{t2}</Box>;
    $[5] = meta.palette;
    $[6] = size;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}